module.exports = __webpack_public_path__ + "static/media/info.a6713b6a.svg";